import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { NumericFormat } from "react-number-format";
import FeeRow from "./FeeRow";
import { useTheme } from "@mui/system";
import { ExpandMore } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../../config";
import { showSnackbar } from "../../../../redux/slices/snackbar";
import { useFormRCAutoDetails } from "../rcautoContext";
import { Pen } from "lucide-react";
import ModificaDialog from "./ModificaDialog";

const Dettagli = ({ idUID, type, dataPreventivo, isReadOnly }) => {
  const { formState, dispatch } = useFormRCAutoDetails();
  let data;

  switch (type) {
    case "RCA":
      if (dataPreventivo) {
        data = dataPreventivo;
      } else {
        data = formState.preventivi?.RCA.find((prev) => prev.idUID === idUID);
      }
      break;
    case "CVT":
      data = formState.preventivi?.CVT.find((prev) => prev.idUID === idUID);
      break;
    case "Assistenza Stradale":
      data = formState.preventivi?.["Assistenza Stradale"].find(
        (prev) => prev.idUID === idUID,
      );
      break;
    default:
      break;
  }
  const [loading, setLoading] = useState(false);
  const csAc = data?.csAc || {};
  const dettagli = data?.dettagli || {};
  const fee = data?.fee || {};
  const frz = data?.frz || {};
  const garanzie = data?.garanzie || { lista: [], totaleGaranzie: 0 };
  const ratino = data?.ratino || {};
  const gI = data?.gI;
  const prezzoTotale = data?.prezzoTotale || 0;
  const prezzoRCA = data?.prezzoRCA || 0;

  const ratinoFee = ratino?.fee?.[0] || [];
  const feeTotale = fee?.feeTot;
  const feeRatinoTotale = ratinoFee?.totaleFee;
  const garanzieTotale = garanzie?.totaleGaranzie;
  const garanzieRatinoTotale = ratino?.garanzie?.totaleGaranzie;

  const [openModifica, setOpenModifica] = useState(false);

  const handleModifica = () => {};

  const navigate = useNavigate();
  const formatter = new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });

  const theme = useTheme();
  const isOverMobile = useMediaQuery(theme.breakpoints.up("sm"));
  const isReadOnlyMode = Boolean(isReadOnly);

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
      },
    },
  };

  const coperturaAnnSem = data?.frz?.coperturaAnnSem;

  const setCoperturaAnnSem = (newValue) => {
    // If user changes radio
    const updatedFrz = {
      ...frz,
      coperturaAnnSem: newValue,
    };
    const newPreventivoData = { ...data, frz: updatedFrz };
    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: newPreventivoData },
    });
  };

  const costiAccordo = {
    scontoFascia: {
      idScontoFascia: csAc?.IdScontoFascia === 0 ? "" : csAc?.IdScontoFascia,
      scontoFascia: csAc?.ScontoFascia,
    },
    scontoMaggiorazione: {
      idTipoScMag: csAc?.IdTipo_Sc_Mag
        ? csAc?.IdTipo_Sc_Mag === 0
          ? ""
          : csAc?.IdTipo_Sc_Mag
        : "",
      idTipoSconto: csAc?.Id_TipoSconto === 0 ? "" : csAc?.Id_TipoSconto,
      valore_Sc_Mag: csAc?.Valore_Sc_Mag,
    },
  };

  const setCostiAccordo = (updater) => {
    const newState = // updater is typically prev => ...
      typeof updater === "function" ? updater(costiAccordo) : updater;

    // Reconstruct csAc section
    const updatedCsAc = {
      ...csAc,
      IdScontoFascia: newState.scontoFascia.idScontoFascia,
      ScontoFascia: newState.scontoFascia.scontoFascia,
      IdTipo_Sc_Mag: newState.scontoMaggiorazione.idTipoScMag,
      Id_TipoSconto: newState.scontoMaggiorazione.idTipoSconto,
      Valore_Sc_Mag: newState.scontoMaggiorazione.valore_Sc_Mag,
    };
    const newPreventivoData = { ...data, csAc: updatedCsAc };
    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: newPreventivoData },
    });
  };

  const checkGaranzie = (garanzie?.lista || []).map((g) => ({
    nome: g.Nome,
    obbligatorio: g.Obbligatorio,
    prezzo: g.Prezzo,
    incluso: g.Incluso,
    checked: g.selezionato,
    id: g.id,
  }));

  const handleChecked = (i) => (e) => {
    // Update specific garanzia selection
    const updatedLista = (garanzie?.lista || []).map((g, idx) =>
      idx === i ? { ...g, selezionato: e.target.checked ? 1 : 0 } : g,
    );
    const newPreventivoData = {
      ...data,
      garanzie: { ...garanzie, lista: updatedLista },
    };
    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: newPreventivoData },
    });
  };

  const checkGaranzieRatino = (ratino?.garanzie?.lista || []).map((g) => ({
    nome: g.Nome,
    obbligatorio: g.Obbligatorio,
    prezzo: g.Prezzo,
    incluso: g.Incluso,
    checked: g.selezionato,
    id: g.id,
  }));

  const handleCheckedRatino = (i) => (e) => {
    const updatedLista = (ratino?.garanzie?.lista || []).map((g, idx) =>
      idx === i ? { ...g, selezionato: e.target.checked ? 1 : 0 } : g,
    );
    const updatedRatino = {
      ...ratino,
      garanzie: { ...ratino.garanzie, lista: updatedLista },
    };
    const newPreventivoData = { ...data, ratino: updatedRatino };
    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: newPreventivoData },
    });
  };
  /* Derived state for fees from the main data object, avoiding duplicate stale state */
  const feePolizza = {
    agente: {
      fee: fee?.FeeAgente,
      idTipoFee: fee?.IdTipofeeAgente,
      totale: fee?.totaleAgente,
    },
    azienda: {
      fee: fee?.FeeAzienda,
      idTipoFee: fee?.IdTipoFeeAzienda,
      totale: fee?.totaleAzienda,
    },
    alca: {
      fee: fee?.FeeAlca,
      idTipoFee: fee?.IdTipofeeAlca,
      totale: fee?.totaleAlca,
    },
  };

  /* Handler to update fees in the global context/formState */
  const setFeePolizza = (updater) => {
    // Determine the new state based on updater (can be function or value)
    const newState =
      typeof updater === "function" ? updater(feePolizza) : updater;

    // Create a new preventivo object with the updated fees
    // We map our local `newState` (agente/azienda/alca) back to the flat structure the API/Data expects
    const updatedFee = {
      ...fee,
      IdTipofeeAgente: newState.agente.idTipoFee,
      FeeAgente: newState.agente.fee,
      totaleAgente: newState.agente.totale,
      IdTipoFeeAzienda: newState.azienda.idTipoFee,
      FeeAzienda: newState.azienda.fee,
      totaleAzienda: newState.azienda.totale,
      IdTipofeeAlca: newState.alca.idTipoFee,
      FeeAlca: newState.alca.fee,
      totaleAlca: newState.alca.totale,
    };

    const newPreventivoData = {
      ...data,
      fee: updatedFee,
    };

    dispatch({
      type: "update_preventivo",
      payload: {
        typePrev: type,
        idUID: idUID,
        preventivo: newPreventivoData,
      },
    });
  };

  const feeRatino =
    Object.keys(ratino).length === 0
      ? null
      : {
          agente: {
            fee: ratinoFee?.feeAgenteRatino ?? null,
            idTipoFee: ratinoFee?.idTipoFeeAgenteRatino ?? null,
            totale: ratinoFee?.totaleAgente ?? null,
          },
          azienda: {
            fee: ratinoFee?.feeAziendaRatino ?? null,
            idTipoFee: ratinoFee?.idTipoFeeAziendaRatino ?? null,
            totale: ratinoFee?.totaleAzienda ?? null,
          },
          alca: {
            fee: ratinoFee?.feeAlcaRatino ?? null,
            idTipoFee: ratinoFee?.idTipoFeeAlcaRatino ?? null,
            totale: ratinoFee?.totaleAlca ?? null,
          },
        };

  const setFeeRatino = (updater) => {
    const newState =
      typeof updater === "function" ? updater(feeRatino) : updater;

    // Reconstruct Ratino Fee array
    const updatedRatinoFee = {
      ...ratinoFee,
      idTipoFeeAgenteRatino: newState.agente.idTipoFee,
      feeAgenteRatino: newState.agente.fee,
      totaleAgenteRatino: newState.agente.totale,
      idTipoFeeAziendaRatino: newState.azienda.idTipoFee,
      feeAziendaRatino: newState.azienda.fee,
      totaleAziendaRatino: newState.azienda.totale,
      idTipoFeeAlcaRatino: newState.alca.idTipoFee,
      feeAlcaRatino: newState.alca.fee,
      totaleAlcaRatino: newState.alca.totale,
    };

    const updatedRatino = {
      ...ratino,
      fee: [updatedRatinoFee], // update the first element
    };

    const newPreventivoData = { ...data, ratino: updatedRatino };
    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: newPreventivoData },
    });
  };

  const ratinoRinnovoChecked = ratino?.ratinoRinnovoValore === 1 ? true : false;

  const setRatinoRinnovo = (checked) => {
    const updatedRatino = {
      ...ratino,
      ratinoRinnovoValore: checked ? 1 : 0,
    };

    const newPreventivoData = { ...data, ratino: updatedRatino };
    dispatch({
      type: "update_preventivo",
      payload: { typePrev: type, idUID, preventivo: newPreventivoData },
    });
  };

  const dispatchSnackbar = useDispatch();
  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  const handleCalcola = async (anteprima = 0) => {
    let updatedData;
    if (anteprima === 1) {
      updatedData = {
        ...data,
        ant: 1,
      };
    } else {
      updatedData = data;
    }

    const endpoint = `${API_BASE_URL}/api/rcAuto/${updatedData?.idUID}/pricing/calculate`;

    setLoading(true);
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          data: updatedData,
        }),
      };

      const response = await fetch(endpoint, requestOptions);
      const res = await response.json();
      console.log(res);

      if (res.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
        handleSnackbar(res.message, "error");
      } else if (res.status === 0) {
        // navigate("/private");
        handleSnackbar(res.message, "error");
        return;
      } else {
        const newPreventivoData = res[0];
        dispatch({
          type: "update_preventivo",
          payload: {
            typePrev: type,
            idUID: idUID,
            preventivo: newPreventivoData,
          },
        });
        handleSnackbar("Ricalcolo effettuato con successo", "success");
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      handleSnackbar("Errore durante il ricalcolo", "error");
    }
  };

  return (
    <Box p={4} border={1} display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between" mb={4}>
        <Box display="flex" alignItems="center" gap={2}>
          {gI === 1 && (
            <Tooltip title="Modifica">
              <IconButton onClick={() => setOpenModifica(true)}>
                <Pen />
              </IconButton>
            </Tooltip>
          )}
          <ModificaDialog
            open={openModifica}
            onClose={() => setOpenModifica(false)}
            idUID={idUID}
            type={type}
          />
          <Typography variant="h4">Preventivo</Typography>
        </Box>
        <Typography variant="h4">
          {"€" +
            formatter
              .format(Number(data?.dettagli?.prezzoPreventivo))
              .replace("€", "")
              .trim()}
        </Typography>
      </Box>
      {frz && (
        <Box display="flex" flexDirection="column" width="100%" py={2}>
          <Box
            display="flex"
            gap={4}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h4">RCA</Typography>
            <Typography variant="h4">
              {"€" +
                formatter.format(Number(prezzoRCA)).replace("€", "").trim()}
            </Typography>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={2}
          >
            <FormControl
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
                ml: 4,
                mr: 8,
              }}
            >
              <RadioGroup
                row
                aria-labelledby="rca"
                name="rca"
                value={coperturaAnnSem}
                onChange={(e) => setCoperturaAnnSem(Number(e.target.value))}
                disabled={isReadOnlyMode}
              >
                {frz?.IdFrazionamento === 1 ? (
                  <Typography fontWeight="bold" fontSize={14}>
                    Annuale
                  </Typography>
                ) : frz?.IdFrazionamento === 2 ? (
                  <Typography fontWeight="bold" fontSize={14}>
                    Semestrale{" "}
                    {frz?.Frazionamento_Valore !== "0" &&
                      `(+${frz?.Frazionamento_Valore}%)`}
                  </Typography>
                ) : (
                  <>
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="Annuale"
                      disabled={isReadOnlyMode}
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label={`Semestrale (+${frz?.Frazionamento_Valore}%)`}
                      disabled={isReadOnlyMode}
                    />
                  </>
                )}
              </RadioGroup>
            </FormControl>

            {"€" +
              formatter
                .format(Number(dettagli?.tariffa))
                .replace("€", "")
                .trim()}
          </Box>
        </Box>
      )}
      <Divider />
      {Object.entries(csAc).length !== 0 && (
        <Accordion
          disableGutters
          sx={{
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="costi-accordo"
            id="costi-accordo"
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <Typography variant="subtitle1" ml={2}>
                Costi Accordo
              </Typography>
              <Typography variant="subtitle1">
                {"€" +
                  formatter
                    .format(Number(csAc?.totalecsAc))
                    .replace("€", "")
                    .trim()}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" gap={2} ml={4}>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Grid item xs={6} sm={8} md={6}>
                  <Grid
                    container
                    alignItems="center"
                    columns={12}
                    direction={{ xs: "column", sm: "row" }}
                  >
                    <Grid item xs={4}>
                      <Typography>Sconto fascia</Typography>
                    </Grid>
                    <Grid item xs={4} width={"100%"}>
                      <FormControl size="small" fullWidth>
                        <Select
                          MenuProps={MenuProps}
                          size="small"
                          disabled={isReadOnlyMode}
                          value={costiAccordo.scontoFascia.idScontoFascia}
                          onChange={(e) =>
                            setCostiAccordo((prev) => ({
                              ...prev,
                              scontoFascia: {
                                ...prev.scontoFascia,
                                idScontoFascia: e.target.value,
                              },
                            }))
                          }
                        >
                          {[
                            { el: "%", id: 1 },
                            { el: "€", id: 2 },
                          ].map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.el}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4} width={"100%"}>
                      <NumericFormat
                        customInput={TextField}
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fullWidth
                        disabled={isReadOnlyMode}
                        value={costiAccordo.scontoFascia.scontoFascia}
                        onValueChange={(e) =>
                          setCostiAccordo((prev) => ({
                            ...prev,
                            scontoFascia: {
                              ...prev.scontoFascia,
                              scontoFascia: String(e.value),
                            },
                          }))
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={4} md={6} sx={{ textAlign: "right" }}>
                  <Typography>
                    {"€" +
                      formatter
                        .format(Number(csAc?.totaleScontoFascia ?? 0))
                        .replace("€", "")
                        .trim()}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", mt: isOverMobile ? 0 : 3 }}
              >
                <Grid item xs={6} sm={8} md={6}>
                  <Grid
                    container
                    alignItems="center"
                    columns={12}
                    direction={{ xs: "column", sm: "row" }}
                  >
                    <Grid item xs={4} width={"100%"}>
                      <FormControl size="small" fullWidth>
                        <Select
                          size="small"
                          MenuProps={MenuProps}
                          disabled={isReadOnlyMode}
                          value={costiAccordo.scontoMaggiorazione.idTipoScMag}
                          onChange={(e) =>
                            setCostiAccordo((prev) => ({
                              ...prev,
                              scontoMaggiorazione: {
                                ...prev.scontoMaggiorazione,
                                idTipoScMag: e.target.value,
                              },
                            }))
                          }
                        >
                          {[
                            { el: "Sconto", id: 1 },
                            { el: "Maggiorazione", id: 2 },
                          ].map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.el}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4} width={"100%"}>
                      <FormControl size="small" fullWidth>
                        <Select
                          MenuProps={MenuProps}
                          size="small"
                          disabled={isReadOnlyMode}
                          value={costiAccordo.scontoMaggiorazione.idTipoSconto}
                          onChange={(e) =>
                            setCostiAccordo((prev) => ({
                              ...prev,
                              scontoMaggiorazione: {
                                ...prev.scontoMaggiorazione,
                                idTipoSconto: e.target.value,
                              },
                            }))
                          }
                        >
                          {[
                            { el: "%", id: 1 },
                            { el: "€", id: 2 },
                          ].map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.el}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4} width={"100%"}>
                      <NumericFormat
                        customInput={TextField}
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fullWidth
                        disabled={isReadOnlyMode}
                        value={costiAccordo.scontoMaggiorazione.valore_Sc_Mag}
                        onValueChange={(e) =>
                          setCostiAccordo((prev) => ({
                            ...prev,
                            scontoMaggiorazione: {
                              ...prev.scontoMaggiorazione,
                              valore_Sc_Mag: String(e.value),
                            },
                          }))
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={4} md={6} sx={{ textAlign: "right" }}>
                  <Typography>
                    {"€" +
                      formatter
                        .format(Number(csAc?.totaleScMag ?? 0))
                        .replace("€", "")
                        .trim()}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      <Divider />
      {(garanzie?.lista || []).length > 0 && (
        <Accordion
          disableGutters
          sx={{
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="garanzie"
            id="garanzie"
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <Typography variant="subtitle1" ml={2}>
                Diritti e Garanzie
              </Typography>
              <Typography variant="subtitle1">
                {"€" +
                  formatter
                    .format(Number(garanzieTotale))
                    .replace("€", "")
                    .trim()}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column">
              {checkGaranzie?.map((garanzia, index) => (
                <Box
                  key={garanzia.id}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="flex" alignItems="center">
                    <Checkbox
                      checked={
                        garanzia.obbligatorio === 1
                          ? true
                          : garanzia.checked === 1
                          ? true
                          : false
                      }
                      disabled={garanzia.obbligatorio === 1 || isReadOnlyMode}
                      onChange={handleChecked(index)}
                    />
                    <Typography>{garanzia.nome}</Typography>
                    {garanzia.incluso === 1 && (
                      <Chip
                        color="success"
                        sx={{ ml: 4, fontWeight: "bold", height: "20px" }}
                        label="Incluso"
                      />
                    )}
                  </Box>
                  <Typography>
                    {"€" +
                      formatter
                        .format(Number(garanzia.prezzo))
                        .replace("€", "")
                        .trim()}
                  </Typography>
                </Box>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      <Divider />
      {Object.entries(fee).length !== 0 && (
        <Accordion
          disableGutters
          sx={{
            backgroundColor:
              theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="fee-polizza"
            id="fee-polizza"
          >
            <Box display="flex" justifyContent="space-between" width="100%">
              <Typography variant="subtitle1" ml={2}>
                Fee
              </Typography>
              <Typography variant="subtitle1">
                {"€" + formatter.format(feeTotale).replace("€", "").trim()}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" gap={2} ml={4}>
              {fee?.FeeAgente !== undefined && fee?.FeeAgente !== null && (
                <FeeRow
                  label="Agente"
                  fieldKey="agente"
                  state={feePolizza}
                  setState={setFeePolizza}
                  MenuProps={MenuProps}
                  disabled={isReadOnlyMode}
                />
              )}
              {fee?.FeeAzienda !== undefined && fee?.FeeAzienda !== null && (
                <FeeRow
                  label="Azienda"
                  fieldKey="azienda"
                  state={feePolizza}
                  setState={setFeePolizza}
                  MenuProps={MenuProps}
                  disabled={isReadOnlyMode}
                />
              )}
              {fee?.FeeAlca !== undefined && fee?.FeeAlca !== null && (
                <FeeRow
                  label="Alca"
                  fieldKey="alca"
                  state={feePolizza}
                  setState={setFeePolizza}
                  MenuProps={MenuProps}
                  disabled={isReadOnlyMode}
                />
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      <Divider />

      {/* Ratino */}
      {Object.entries(ratino).length !== 0 && (
        <>
          <Box display="flex" justifyContent="space-between" mb={2} mt={4}>
            <Typography variant="h4">Ratino</Typography>
            <Typography variant="h4">
              {"€" +
                formatter
                  .format(Number(data?.ratino?.prezzoRatinoTotale))
                  .replace("€", "")
                  .trim()}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mt={2}>
            <Typography mb={2} ml={4} mr={8}>
              Ratino dal{" "}
              <span style={{ fontWeight: "bold" }}>
                {ratino?.dataDecorrenza}{" "}
              </span>{" "}
              al{" "}
              <span style={{ fontWeight: "bold" }}>
                {ratino?.scadenzaLibroMatricola}{" "}
              </span>
              ({ratino?.ratinoGiorni} giorni){" "}
            </Typography>

            {"€" +
              formatter
                .format(Number(data?.ratino?.prezzoRatino))
                .replace("€", "")
                .trim()}
          </Box>
          {ratino?.ratinoRinnovo === 1 && (
            <Box display="flex" alignItems="center" mb={2}>
              <Checkbox
                checked={ratinoRinnovoChecked}
                onChange={() => setRatinoRinnovo(!ratinoRinnovoChecked)}
                disabled={
                  isReadOnlyMode ||
                  (ratino?.ratinoRinnovoStsDsb === 1 ? false : true)
                }
              />
              <Typography>Ratino + Rinnovo</Typography>
            </Box>
          )}

          <Accordion
            disableGutters
            sx={{
              backgroundColor:
                theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="ratino"
              id="ratino"
            >
              <Box display="flex" justifyContent="space-between" width="100%">
                <Typography variant="subtitle1" ml={2}>
                  Fee
                </Typography>
                <Typography variant="subtitle1">
                  {"€" +
                    formatter
                      .format(Number(feeRatinoTotale))
                      .replace("€", "")
                      .trim()}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box display="flex" flexDirection="column" gap={2} ml={4}>
                {feeRatino !== null && (
                  <>
                    {ratinoFee.feeAgenteRatino !== undefined &&
                      ratinoFee.feeAgenteRatino !== null && (
                        <FeeRow
                          label="Agente"
                          fieldKey="agente"
                          state={feeRatino}
                          setState={setFeeRatino}
                          MenuProps={MenuProps}
                          disabled={isReadOnlyMode}
                        />
                      )}
                    {ratinoFee.feeAziendaRatino !== undefined &&
                      ratinoFee.feeAziendaRatino !== null && (
                        <FeeRow
                          label="Azienda"
                          fieldKey="azienda"
                          state={feeRatino}
                          setState={setFeeRatino}
                          MenuProps={MenuProps}
                          disabled={isReadOnlyMode}
                        />
                      )}
                    {ratinoFee.feeAlcaRatino !== undefined &&
                      ratinoFee.feeAlcaRatino !== null && (
                        <FeeRow
                          label="Alca"
                          fieldKey="alca"
                          state={feeRatino}
                          setState={setFeeRatino}
                          MenuProps={MenuProps}
                          disabled={isReadOnlyMode}
                        />
                      )}
                  </>
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
          <Divider />
          {/* Diritti e garanzie Ratino */}
          {ratino?.garanzie?.lista?.length > 0 && (
            <Accordion
              disableGutters
              sx={{
                backgroundColor:
                  theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="diritti-e-garanzie-ratino"
                id="diritti-e-garanzie-ratino"
              >
                <Box display="flex" justifyContent="space-between" width="100%">
                  <Typography variant="subtitle1" ml={2}>
                    Diritti e Garanzie
                  </Typography>
                  <Typography variant="subtitle1">
                    {"€" +
                      formatter
                        .format(Number(garanzieRatinoTotale))
                        .replace("€", "")
                        .trim()}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box display="flex" flexDirection="column">
                  {checkGaranzieRatino?.map((garanzia, index) => (
                    <Box
                      key={garanzia.id}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={
                            garanzia.obbligatorio === 1
                              ? true
                              : garanzia.checked === 1
                              ? true
                              : false
                          }
                          disabled={
                            garanzia.obbligatorio === 1 || isReadOnlyMode
                          }
                          onChange={handleCheckedRatino(index)}
                        />
                        <Typography>{garanzia.nome}</Typography>
                        {garanzia.incluso === 1 && (
                          <Chip
                            color="success"
                            sx={{
                              ml: 4,
                              fontWeight: "bold",
                              height: "20px",
                            }}
                            label="Incluso"
                          />
                        )}
                      </Box>
                      <Typography>
                        {"€" +
                          formatter
                            .format(Number(garanzia.prezzo))
                            .replace("€", "")
                            .trim()}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
        </>
      )}

      {/* Totale */}
      <Divider />
      <Box display="flex" justifyContent="space-between" my={8}>
        <Typography fontSize="bold" variant="h4">
          Totale
        </Typography>
        <Typography fontSize="bold" variant="h4">
          {"€" +
            formatter
              .format(Number(data?.prezzoTotale))
              .replace("€", "")
              .trim()}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="end" gap={4}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleCalcola(1)}
          disabled={isReadOnlyMode}
        >
          Anteprima
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={() => handleCalcola(0)}
          disabled={isReadOnlyMode}
        >
          Aggiorna
        </Button>
      </Box>
    </Box>
  );
};

export default Dettagli;
